import React, { Component } from 'react';
import cn from 'classnames';
import css from './css.css';
// import { Col } from 'react-flexbox-grid';
import { Col } from '~/native-ui';

export default class StyledCol extends Component {
	static propTypes = {
	
	};

    levelOuterClassName = () => {
        let { level } = this.props;
        return level ? cn(css[`level${level}Outer`], css.levelOuter) : null;
    };

    levelClassName = () => {
        let { level } = this.props;
        return level ? cn(css[`level${level}`], css.level) : null;
    };

    wrapLevelled = (rendered) => {
        let  { level, xs, md, lg,  sm,  } = this.props;

        const props = {
            xs, md, lg,  sm,
            shadow: level,
        };

        return (
            <Col { ...props }>
                {rendered}
            </Col>
        );
    };


    render() {
	    let { className, children, level, style, ...props } = this.props;

		return (
            // <div {...props} style={[ props.style ]}>
                // {this.wrapLevelled(children)}
                this.wrapLevelled(children)
            // </div>
		);
	}
}